module.exports = __webpack_public_path__ + "img/flower-bg.e91b528a.jpg";